import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// get the last part of the pathname
// for example: /category/brands -> brands

export const extractPathname = (pathname: string) => {
  const paths = pathname.split('/');
  return paths[paths.length - 1];
};

export const getImageSrc = (value: string): string => {
  if (!value) return '';
  if (
    value.startsWith('data:') ||
    value.startsWith('http') ||
    value.startsWith('/')
  )
    return value;
  if (value.startsWith('/9j/')) return `data:image/jpeg;base64,${value}`;
  if (value.startsWith('iVBOR')) return `data:image/png;base64,${value}`;
  return `data:image/jpeg;base64,${value}`;
};
